import createConverter from './lib/create_converter';
import CustomerProfile from 'models/customer_profile';

export default createConverter(CustomerProfile);
